// Public Privacy Notice. Generic, non-clinical demo deployment posture —
// have your covered entity / privacy officer review before live use.

import LegalLayout from './LegalLayout.jsx';

export default function LegalPrivacy() {
  return (
    <LegalLayout title="Privacy Notice" lastUpdated={LAST_UPDATED}>
      <p>
        This notice describes how the {APP} platform handles personal and
        health information processed in the course of operating the Service
        for participating healthcare facilities.
      </p>

      <h2>Information we process</h2>
      <ul>
        <li><strong>Account data</strong> — name, email, role, facility, audit logs of activity.</li>
        <li><strong>Patient data</strong> — identifiers (MRN, name), prescriptions, deliveries, payments, and consent records, processed on behalf of the facility ("covered entity") as a business associate.</li>
        <li><strong>Payment data</strong> — amounts, status, last four digits of card, processor transaction IDs. Card numbers are processed directly by Stripe and do not pass through our servers (PCI scope SAQ-A).</li>
        <li><strong>Communications metadata</strong> — when an SMS pay link or email receipt is sent, we record the recipient, send time, delivery status, and any error codes returned by the carrier or vendor.</li>
      </ul>

      <h2>How we use information</h2>
      <p>
        Strictly to operate the Service: facilitate medication delivery,
        capture consent, process payments, audit access, and provide
        receipts and pay links to patients when their care team initiates one.
      </p>

      <h2>Sharing</h2>
      <ul>
        <li>With your healthcare facility (the data controller / covered entity).</li>
        <li>With sub-processors — Stripe (payments), Twilio (SMS), and an email provider (receipts) — under contractual safeguards. In demo deployments, the email provider may be SendGrid's free tier, which does <em>not</em> include a Business Associate Agreement; demo deployments minimize PHI in email content accordingly.</li>
        <li>When required by law.</li>
      </ul>

      <h2>Security</h2>
      <p>
        We use TLS in transit, role-based access control, audit logging,
        per-facility data scoping, and minimum-necessary disclosure on
        outbound communications. Card data is never stored on our servers.
      </p>

      <h2>Patient rights</h2>
      <p>
        If you are a patient, your rights to access, correct, or restrict the
        use of your information are administered by your healthcare facility.
        Contact them directly using the numbers on the
        <a href="/help/faq"> FAQ &amp; Help page</a>.
      </p>

      <h2>Retention</h2>
      <p>
        Records are retained per the facility's policies and applicable law.
        Payment audit records are retained at least seven years.
      </p>

      <h2>Contact</h2>
      <p>
        For privacy questions, contact your facility's Privacy Officer using
        the contact information on the <a href="/help/faq">FAQ &amp; Help page</a>.
      </p>

      <p className="text-xs text-slate-500 mt-8">
        This is a generic notice for a demo deployment. A live deployment
        must publish a notice tailored to the covered entity's actual
        practices, sub-processor list, and BAA coverage.
      </p>
    </LegalLayout>
  );
}

const APP = 'Meds-to-Beds';
const LAST_UPDATED = '2026-04-25';
